import jwtDecode from "jwt-decode";
import { useState } from "react";

const HourFormat=()=>{
    const token =localStorage.getItem("token") &&
    localStorage.getItem("token") !== "undefined"
    ? localStorage.getItem("token")
    : null
    var decodedToken=token && token !== "undefined" ? jwtDecode(token) : null
      // Decode the token and extract the full name
     return decodedToken?.hours24?"HH:mm":"h:mmaa";
}
export default HourFormat